// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterForm__hgroup":"op_a bhj_a bhj_x","FilterForm__vgroup":"op_b bhj_rp"};